function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgTelegramBlack = function SvgTelegramBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.8203C24 19.4477 18.6274 24.8203 12 24.8203C5.37258 24.8203 0 19.4477 0 12.8203C0 6.1929 5.37258 0.820312 12 0.820312C18.6274 0.820312 24 6.1929 24 12.8203ZM12.43 9.67924C11.2628 10.1647 8.93014 11.1695 5.43189 12.6936C4.86383 12.9195 4.56626 13.1405 4.53917 13.3566C4.49339 13.7218 4.95071 13.8656 5.57347 14.0614C5.65818 14.0881 5.74595 14.1157 5.83594 14.1449C6.44864 14.3441 7.27283 14.5771 7.70129 14.5863C8.08994 14.5947 8.52373 14.4345 9.00264 14.1057C12.2712 11.8993 13.9584 10.7841 14.0643 10.7601C14.139 10.7431 14.2426 10.7218 14.3128 10.7842C14.3829 10.8465 14.376 10.9646 14.3686 10.9963C14.3233 11.1895 12.5281 12.8584 11.5991 13.7221C11.3095 13.9913 11.1041 14.1823 11.0621 14.2259C10.968 14.3237 10.8721 14.4161 10.78 14.5049C10.2108 15.0536 9.78391 15.4651 10.8036 16.1371C11.2936 16.46 11.6858 16.7271 12.077 16.9935C12.5042 17.2844 12.9303 17.5746 13.4816 17.936C13.6221 18.0281 13.7562 18.1237 13.8869 18.2168C14.3841 18.5713 14.8307 18.8897 15.3826 18.8389C15.7032 18.8094 16.0345 18.5079 16.2027 17.6087C16.6002 15.4835 17.3816 10.8788 17.5622 8.98129C17.578 8.81504 17.5581 8.60228 17.5422 8.50889C17.5262 8.41549 17.4928 8.28242 17.3714 8.18391C17.2276 8.06725 17.0056 8.04265 16.9064 8.0444C16.455 8.05235 15.7626 8.29313 12.43 9.67924Z",
    fill: "#121212"
  }));
};
export default SvgTelegramBlack;